import React, { Component } from "react";
import styled from "styled-components";
import { graphql } from "react-apollo";
import Moment from "moment";
import { queryGetChannels } from "Apollo";
import Card from "./Card";

export default graphql(queryGetChannels)(
  class List extends Component {
    render() {
      const { getCompanyChannelHandler } = this.props.data;
      const renders = [];
      if (getCompanyChannelHandler) {
        for (const channel of getCompanyChannelHandler) {
          renders.push(
            <Card
              key={channel.id}
              id={channel.id}
              name={channel.name}
              displayName={channel.displayName}
              displayPicture={channel.displayPicture}
              dateCreated={Moment(channel.dateCreated)}
              channel={channel.channel.name}
              color={"#" + channel.color}
              nickName={channel.nickName}
            />
          );
        }
      }
      return <Wrapper>{renders}</Wrapper>;
    }
  }
);

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/channel-panel/ListWithQuery.js